import { IProperty } from '../models/AndromeTV.types';
import { PageType } from '../models/Shared.types';
import { StaticPageUrls } from './ClientEvents';

export function addProperty(name: string, value: any, excluded: string[], properties: IProperty[]) {
  if (!excluded.includes(name) && value) {
    if (!Number.isNaN(value)) {
      value = value.toString();
    }
    properties.push({
      name,
      value,
    });
  }
}

export function recordingPageTypeToAnalytics(pageType: string): string | undefined {
  switch (pageType) {
    case PageType.RecordingPlanned:
      return StaticPageUrls.myStuffRecordingsPlanned;
    case PageType.RecordingRecorded:
      return StaticPageUrls.myStuffRecordingsRecorded;
    case PageType.RecordingExpired:
      return StaticPageUrls.myStuffRecordingsExpired;
  }
}
